module.exports = __webpack_public_path__ + "static/img/AD@3x.c8a83b57.jpg";